export default 'm10 17.41-4.7-4.7 1.4-1.42 3.3 3.3 7.3-7.3 1.4 1.42zM24 12a12 12 0 1 1-24 0 12 12 0 0 1 24 0M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20';